// import Dashboard from "../pages/Dashboard";
// import SearchClient from "../pages/Payment/SearchClient";
// import ListPayments from "../pages/Payment/ListPayments";

export const clientRoutes = {
	searchClient: "/clientes",
	updateClient: "/clientes/cliente-natural",
	listAddressClient: "/clientes/lista-de-direcciones",
	updateAdressClient: "/clientes/actualizar-direccion",
	listReferencesClient: "/clientes/lista-de-referencias",
	updateReferenceClient: "/clientes/actualizar-referencia",
	financialSituationClient: "/clientes/situacion-financiera",
	listCredits: "/clientes/creditos",
	listObservations: "/clientes/observaciones",
};

export const clientViewInfoRoutes = {
	searchClient: "/consultaclientes",
	updateClient: "/consultaclientes/cliente-natural",
	listAddressClient: "/consultaclientes/lista-de-direcciones",
	updateAdressClient: "/consultaclientes/direccion",
	listReferencesClient: "/consultaclientes/lista-de-referencias",
	updateReferenceClient: "/consultaclientes/referencia",
	financialSituationClient: "/consultaclientes/situacion-financiera",
	listCredits: "/consultaclientes/creditos",
	listObservations: "/consultaclientes/observaciones",
};

export const portfolioManagmentRoutes = {
	createTable: "/portfolioManagment/createTable",
};

// const CustomPropsBreadcrumb = ({ someProp }) => <span>{someProp}</span>;

export const routes = [
	{
		path: "/",
		breadcrumb: "",
	},
	{
		path: "/usuarios",
		breadcrumb: "Usuarios",
	},
	{
		path: "/clientes",
		breadcrumb: "Mantenimiento Clientes",
	},
	{
		path: "/consultaclientes",
		breadcrumb: "Consulta Clientes",
	},
	{
		path: "/clienteexcepcion",
		breadcrumb: "Excepcion Cliente",
	},
	{
		path: "/parametrosnumericos",
		breadcrumb: "Parámetros Numéricos",
	},
	{
		path: "/politicas",
		breadcrumb: "Politicas",
	},
	{
		path: "/pagocuotas",
		breadcrumb: "Pago de Cuotas",
	},
	{
		path: "/gastocobranza",
		breadcrumb: "Gasto Cobranza",
	},
	{
		path: "/reversos",
		breadcrumb: "Reversos",
	},
	{
		path: "/procesosespecialescredito",
		breadcrumb: "Procesos Especiales de Credito",
	},
	{
		path: "/procesosespecialescartera",
		breadcrumb: "Procesos Especiales de Cartera",
	},
	{
		path: "/documentoscredito",
		breadcrumb: "Documentos de Credito",
	},
	{
		path: "/fabricacredito",
		breadcrumb: "Fabrica de Credito",
	},
	{
		path: "/reportes",
		breadcrumb: "Reportes",
	},
	{
		path: "/plantillas",
		breadcrumb: "Plantillas",
	},
	{
		path: "/ejecucionplantillas",
		breadcrumb: "Ejecucion",
	},
	{
		path: "/consultas",
		breadcrumb: "Consultas",
	},
	{
		path: "/procesosmasivos",
		breadcrumb: "Procesos Masivos",
	},
	{
		path: "/soporte",
		breadcrumb: "Soporte",
	},
	{
		path: "/catalogos",
		breadcrumb: "Catálogos",
	},

	{
		path: "/pagospichincha",
		breadcrumb: "Pagos pichincha",
	},

	{
		path: "/configuracionpagos",
		breadcrumb: "Configuración pagos",
	},
	{
		path: "/metodospago",
		breadcrumb: "Métodos de pago",
	},
	{
		path: "/mantenimientoagencia",
		breadcrumb: "Mantenimiento agencia",
	},
	{
		path: "/mantenimientoempresa",
		breadcrumb: "Mantenimiento empresa",
	},
	{
		path: "/mantenientotasas",
		breadcrumb: "Tasas y Seguros",
	},
	{
		path: "/generarventa",
		breadcrumb: "Generar Venta",
	},
	{
		path: "/procesoventas",
		breadcrumb: "Procesar Venta",
	},
	{
		path: "/solicitar",
		breadcrumb: "Solicitar autorización",
	},
	{
		path: "/autorizar",
		breadcrumb: "Aprobar autorización",
	},
	{
		path: "/productosfinancieros",
		breadcrumb: "Productos Financieros",
	},
	{
		path: "/ventanamenu",
		breadcrumb: " ",
	},
	{
		path: "/mantenimientoperfil",
		breadcrumb: "Mantenimiento Perfil Usuarios",
	},
	{
		path: "/ventanamenu/ventana",
		breadcrumb: "Mantenimiento de Opciones",
	},
	{
		path: "/ventanamenu/opcion",
		breadcrumb: "Mantenimiento del Menú",
	},
	{
		path: "/ventanamenu/perfil",
		breadcrumb: "Mantenimiento de Perfil Menú/Opción",
	},
	{
		path: "/ventanamenu/perfilopcion",
		breadcrumb: "Mantenimiento de Perfil Menú",
	},
	{
		path: "/reportescartera",
		breadcrumb: "Reporte de Saldos de Cartera",
	},
	{
		path: "/adminempresacobranza",
		breadcrumb: "Mant. Empresas de Cobranza",
	},
	{
		path: "/adminempresacobranza/crear/",
		breadcrumb: "Crear",
	},
	{
		path: "/adminempresacobranza/actualizar/",
		breadcrumb: "Actualizar",
	},
	{
		path: "/cargaempresacobranza",
		breadcrumb: "Carga de Empresas de Cobranza",
	},
	{
		path: "/cuotasgratis",
		breadcrumb: "Cuotas Gratis",
	},
	{
		path: "/mantrequestlogs",
		breadcrumb: "Revisión Logs de APIs",
	},
	{
		path: "/comportcrediticio",
		breadcrumb: "Parámetros de Comportamiento Crediticio",
	},
	{
		path: "/reportespagos",
		breadcrumb: "Reportes de pagos",
	},
	{
		path: "/catalogosseg",
		breadcrumb: "Catálogos",
	},
	{
		path: "/infvariable",
		breadcrumb: "Información Variable",
	},
	{
		path: "/desccobranza",
		breadcrumb: "Descuento Cobranza",
	},
	{
		path: "/desccobranza/listacuotasdesc",
		breadcrumb: "Lista Cuotas Descuento Cobranza",
	},
	{
		path: "/reportesdesccobranza",
		breadcrumb: "Reporte de Descuentos de Cobranza",
	},
	{
		path: "/botonvariable",
		breadcrumb: "Botón Variable",
	},
	{
		path: "/prodtcliente",
		breadcrumb: "Cambio IMEI/candado",
	},
	{
		path: "/prodtcliente/listcredits",
		breadcrumb: "Lista Créditos",
	},
	{
		path: "/prodtcliente/listcredits/listproducts/",
		breadcrumb: "Lista Productos",
	},
	{
		path: "/reporterecaudacion",
		breadcrumb: "Reporte de Recaudación",
	},
	{
		path: "/reportescarterawiicar",
		breadcrumb: "Reporte de Saldos de Cartera",
	},
	{
		path: "/enviodocsmail",
		breadcrumb: "Envío Documentos Mail",
	},
	{
		path: "/anucreditogen/anular-creditogen",
		breadcrumb: "Anulación Crédito",
	},
	{
		path: "/anucreditogen",
		breadcrumb: "Anulación de Crédito ",
	},
	{
		path: "/reversosprecancelacion",
		breadcrumb: "Reversos precancelacióm ",
	},
	{
		path: "/gastocobranzadias",
		breadcrumb: "Gasto Cobranza Días",
	},
	{
		path: "/cartolaw",
		breadcrumb: "Consulta Cartola",
	},
	{
		path: "/reporterecaudacion_wiicar",
		breadcrumb: "Reporte de Recaudación",
	},
	{
		path: "/manttablasclientes",
		breadcrumb: "Mantenimiento de Tablas de Clientes",
	},
	{
		path: "/mantseguros",
		breadcrumb: "Mantenimiento de Seguros",
	},
	{
		path: "/cambiocuenta",
		breadcrumb: "Cambio Cuenta Bancaria",
	},
	{
		path: "/cambiocuenta/listcredits",
		breadcrumb: "Créditos",
	},
	{
		path: "/cambiocuenta/listcredits/listaccount",
		breadcrumb: "Cuentas",
	},
	{
		path: "/reportescarteraedad",
		breadcrumb: "Reporte de Cartera por Edades",
	},
	{
		path: "/reportesdescmora",
		breadcrumb: "Reporte de Descuentos de Mora",
	},
	{
		path: "/prodtplaca",
		breadcrumb: "Cambio Placa",
	},
	{
		path: "/prodtplaca/listcredits/listplacas",
		breadcrumb: "Modificación",
	},
	{
		path: "/prodtplaca/listcredits",
		breadcrumb: "Listado de Créditos",
	},
	{
		path: "/rubrosa",
		breadcrumb: "Rubros Adicionales",
	},
	{
		path: "/rubrosa/listarubros",
		breadcrumb: "Lista Rubros",
	},
	{
		path: "/mantsegurosmasivo",
		breadcrumb: "Carga Seguros Masivos",
	},
	{
		path: "/ventacarteraw",
		breadcrumb: "Generar Venta Cartera",
	},
	{
		path: "/generarventaw",
		breadcrumb: "Procesar Venta Cartera",
	},
];
